import { isArray, isObject } from '@websolutespa/bom-core';

export type IPaginationLegacyInfo<T = any> = {
  items: T[],
  page: number,
  pages: number,
  perPage: number,
  total: number,
};

export function isPaginationLegacyInfo(item: unknown): item is IPaginationLegacyInfo<any> {
  return isObject(item) && (
    typeof item.page === 'number' &&
    typeof item.pages === 'number' &&
    typeof item.total === 'number' &&
    isArray(item.items)
  );
}

export function getPagedItemsLegacy<T>(items: T[], page: number, perPage: number): T[] {
  const from = (page - 1) * perPage;
  const to = Math.min(page * perPage, items.length);
  return items.slice(from, to);
}

export function getPaginationLegacyInfo<T>(items: T[], page: number = 1, perPage: number = 15): IPaginationLegacyInfo<T> {
  const total = items.length;
  const pages = Math.ceil(total / perPage);
  const pagedItems = getPagedItemsLegacy(items, page, perPage);
  // console.log(items.length, '->', pagedItems.length);
  return { items: pagedItems, total, pages, page, perPage };
}
